import { ROOM_TYPES, type RoomTypeValue } from '@/entities/visit-counsel/model/house-sketch.types';
import { recoverRoomType } from '@/entities/visit-counsel/model/recoverRoomType';
import type { SketchingSessionRoom } from '@/entities/visit-counsel/model/visit-counsel.types';

const ROOM_TYPE_VALUES = new Set<string>(ROOM_TYPES.map((r) => r.value));

export function isRoomTypeValue(value: string): value is RoomTypeValue {
  return ROOM_TYPE_VALUES.has(value);
}

/** sketching 룸 → ItemPicker 섹션 분류용 RoomType */
export function roomTypeFromSketchRoom(
  room: Pick<SketchingSessionRoom, 'type' | 'namePrefix'>
): RoomTypeValue | undefined {
  const recovered = recoverRoomType(room);
  return isRoomTypeValue(recovered) ? recovered : undefined;
}

/** additional space session 의 spaceType 이 RoomType 이면 그대로 사용 */
export function roomTypeFromSpaceType(spaceType: string): RoomTypeValue | undefined {
  return isRoomTypeValue(spaceType) ? spaceType : undefined;
}
